import React, { useEffect } from "react";
import LetsTalkButton from "../components/LetsTalkButton";
import "../styles/technology.css";

export default function Technology() {
  useEffect(() => {
    document.title = "Technology | Inypeople";
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <section className="technology-hero-section">
        <div className="technology-hero-content">
          <h1 className="technology-hero-title">
            Technology That Empowers
          </h1>
          <h2 className="technology-hero-highlight">
            People &amp; Performance
          </h2>
          <p className="technology-hero-description">
            Modern infrastructure built for scale, security, and seamless user experience.<br />
            Transform your business with cutting-edge technology designed for the future.
          </p>
      </div>
    </section>

      {/* WHY OUR TECHNOLOGY SECTION */}
      <section className="why-our-technology-section">
        <div className="why-our-technology-container">
          <h2 className="why-our-technology-title">Why Our Technology</h2>
          <p className="why-our-technology-subtitle">
            Built on a foundation of reliability, security, and performance
          </p>
          <div className="why-our-technology-cards">
            {/* Card 1 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_cloud.png"}
                  alt="Cloud-Based Architecture"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">Cloud-Based Architecture</h3>
              <p className="why-tech-card-desc">
                Secure, scalable, and accessible anytime, anywhere.
              </p>
            </div>
            {/* Card 2 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_user.png"}
                  alt="User-Friendly Interface"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">User-Friendly Interface</h3>
              <p className="why-tech-card-desc">
                Intuitive design that reduces learning time and boosts productivity.
              </p>
            </div>
            {/* Card 3 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_performance.png"}
                  alt="High Performance & Reliability"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">High Performance & Reliability</h3>
              <p className="why-tech-card-desc">
                Optimized for speed, stability, and consistent results.
              </p>
            </div>
            {/* Card 4 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_scalable.png"}
                  alt="Scalable & Future-Ready"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">Scalable & Future-Ready</h3>
              <p className="why-tech-card-desc">
                Grows effortlessly with your business needs.
              </p>
            </div>
            {/* Card 5 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_secure.png"}
                  alt="Secure by Design"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">Secure by Design</h3>
              <p className="why-tech-card-desc">
                Built with industry-standard security and data protection.
              </p>
            </div>
            {/* Card 6 */}
            <div className="why-tech-card">
              <div className="why-tech-icon-bg">
                <img
                  src={process.env.PUBLIC_URL + "/assets/icons/tech_integration.png"}
                  alt="Seamless Integration"
                  className="why-tech-icon-img"
                />
              </div>
              <h3 className="why-tech-card-title">Seamless Integration</h3>
              <p className="why-tech-card-desc">
                Easily connects with existing tools and platforms.
              </p>
            </div>
          </div>
        </div>
      </section>

            {/* TECHNOLOGY STACK SECTION */}
            <section className="tech-stack-section">
              <div className="tech-stack-container">
                <h2 className="tech-stack-title">Technology Stack</h2>
                <p className="tech-stack-desc">Powered by industry-leading technologies and frameworks</p>
                <div className="tech-stack-visual">
                  {/* Outer Circles */}
                  <div className="tech-stack-circles-bg">
                    {/* <div className="tech-stack-circle tech-stack-circle1"></div>
                    <div className="tech-stack-circle tech-stack-circle2"></div>
                    <div className="tech-stack-circle tech-stack-circle3"></div> */}
                  </div>
                  {/* Main Row */}
                  <div className="tech-stack-main-row">
                    {/* Column: Frontend */}
                    <div className="tech-stack-main-col">
                       <span className="tech-stack-icon-label">React</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/react.png"} alt="React" /></div>
                      <div className="tech-stack-dotted-line-title"></div>
                      <div className="tech-stack-title-bg">Frontend</div>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/typescript.png"} alt="TypeScript" /></div>
                      <span className="tech-stack-icon-label">TypeScript</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/tailwind.png"} alt="Tailwind CSS" /></div>
                      <span className="tech-stack-icon-label">Tailwind CSS</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/nextjs.png"} alt="Next.js" /></div>
                      <span className="tech-stack-icon-label">Next.js</span>
                    </div>
                    {/* Column: Backend */}
                    <div className="tech-stack-main-col">
                      <span className="tech-stack-icon-label">Node.js</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/nodejs.png"} alt="Node.js" style={{width: "40px", height: "40px"}} /></div>                      
                      <div className="tech-stack-dotted-line-title"></div>
                      <div className="tech-stack-title-bg">Backend</div>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/python.png"} alt="Python" /></div>
                      <span className="tech-stack-icon-label">Python</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/java.png"} alt="Java" style={{width: "60px", height: "60px"}} /></div>
                      <span className="tech-stack-icon-label">Java</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/api.png"} alt="REST APIs" /></div>
                      <span className="tech-stack-icon-label">REST APIs</span>
                    </div>
                    {/* Column: Database */}
                    <div className="tech-stack-main-col">
                      <span className="tech-stack-icon-label">Elasticsearch</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/elasticsearch.png"} alt="Elasticsearch" /></div>                      
                      <div className="tech-stack-dotted-line"></div>
                      <span className="tech-stack-icon-label">MySQL</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/mysql.png"} alt="MySQL" style={{width: "45px", height: "45px"}} /></div>                      
                      <div className="tech-stack-dotted-line-title"></div>
                      <div className="tech-stack-title-bg">Database</div>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/postgresql.png"} alt="PostgreSQL" style={{width: "40px", height: "40px"}} /></div>
                      <span className="tech-stack-icon-label">PostgreSQL</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/mongodb.png"} alt="MongoDB" style={{width: "50px", height: "50px"}}/></div>
                      <span className="tech-stack-icon-label">MongoDB</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/redis.png"} alt="Redis" /></div>
                      <span className="tech-stack-icon-label">Redis</span>
                    </div>
                    {/* Column: Cloud & Hosting */}
                    <div className="tech-stack-main-col">
                      <span className="tech-stack-icon-label">DevOps</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/devops.png"} alt="DevOps" style={{width: "50px", height: "50px"}} /></div>
                      <div className="tech-stack-dotted-line"></div>
                      <span className="tech-stack-icon-label">AWS</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/aws.png"} alt="AWS"  style={{width: "50px", height: "50px"}} /></div>
                      <div className="tech-stack-dotted-line-title"></div>
                      <div className="tech-stack-title-bg">Cloud &amp; Hosting</div>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/docker.png"} alt="Docker" style={{width: "50px", height: "50px"}} /></div>
                      <span className="tech-stack-icon-label">Docker</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/kubernetes.png"} alt="Kubernetes" /></div>
                      <span className="tech-stack-icon-label">Kubernetes</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/terraform.png"} alt="Terraform" /></div>
                      <span className="tech-stack-icon-label">Terraform</span>
                      
                    </div>
                    {/* Column: Security */}
                    <div className="tech-stack-main-col">
                      <span className="tech-stack-icon-label">OAuth 2.0</span>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/oauth.png"} alt="OAuth 2.0" style={{width: "60px", height: "60px"}} /></div>  
                      <div className="tech-stack-dotted-line-title"></div>
                      <div className="tech-stack-title-bg">Security</div>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/jwt.png"} alt="JWT" /></div>
                      <span className="tech-stack-icon-label">JWT</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/ssl.png"} alt="SSL/TLS" style={{width: "40px", height: "40px"}} /></div>
                      <span className="tech-stack-icon-label">SSL/TLS</span>
                      <div className="tech-stack-dotted-line"></div>
                      <div className="tech-stack-icon-outer"><img src={process.env.PUBLIC_URL + "/assets/icons/encryption.png"} alt="Encryption" style={{width: "50px", height: "50px"}} /></div>
                      <span className="tech-stack-icon-label">Encryption</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
      {/* SMART FEATURES SECTION */}
      <section className="smart-features-section">
        <div className="smart-features-container">
          <h2 className="smart-features-title">Smart Features Powered by Technology</h2>
          <p className="smart-features-desc">Intelligent capabilities that transform how you work</p>
          <div className="smart-features-cards">
            {/* Card 1 */}
            <div className="smart-feature-card">
              <div className="smart-feature-icon-bg">
                <img src={process.env.PUBLIC_URL + "/assets/icons/feature_automation.png"} alt="Intelligent Automation" className="smart-feature-icon-img" />
              </div>
              <div className="smart-feature-content">
                <h3 className="smart-feature-card-title">Intelligent Automation</h3>
                <p className="smart-feature-card-desc">Automate repetitive tasks and workflows with smart triggers and conditions. Save hours of manual work every week.</p>
              </div>
            </div>
            {/* Card 2 */}
            <div className="smart-feature-card">
              <div className="smart-feature-icon-bg">
                <img src={process.env.PUBLIC_URL + "/assets/icons/feature_analytics.png"} alt="Advanced Analytics" className="smart-feature-icon-img" />
              </div>
              <div className="smart-feature-content">
                <h3 className="smart-feature-card-title">Advanced Analytics</h3>
                <p className="smart-feature-card-desc">Real-time insights and predictive analytics help you make data-driven decisions with confidence.</p>
              </div>
            </div>
            {/* Card 3 */}
            <div className="smart-feature-card">
              <div className="smart-feature-icon-bg">
                <img src={process.env.PUBLIC_URL + "/assets/icons/feature_workflow.png"} alt="Custom Workflows" className="smart-feature-icon-img" />
              </div>
              <div className="smart-feature-content">
                <h3 className="smart-feature-card-title">Custom Workflows</h3>
                <p className="smart-feature-card-desc">Build powerful workflows that adapt to your business processes without writing a single line of code.</p>
              </div>
            </div>
            {/* Card 4 */}
            <div className="smart-feature-card">
              <div className="smart-feature-icon-bg">
                <img src={process.env.PUBLIC_URL + "/assets/icons/feature_employee.png"} alt="Employee Management" className="smart-feature-icon-img" />
              </div>
              <div className="smart-feature-content">
                <h3 className="smart-feature-card-title">Employee Management</h3>
                <p className="smart-feature-card-desc">Streamline onboarding, performance tracking, and team collaboration in one unified platform.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* OUR COMMITMENT SECTION */}
      <section className="commitment-section">
        <div className="commitment-container">
          <h2 className="commitment-title">Our Commitment to Excellence</h2>
          <div className="commitment-features-grid">
            <div className="commitment-feature">
              <img src={process.env.PUBLIC_URL + "/assets/icons/commit.png"} alt="24/7 Monitoring" className="commitment-feature-icon" />
              <div className="commitment-feature-content">
                <span className="commitment-feature-title">24/7 Monitoring</span>
                <div className="commitment-feature-desc">Continuous system health checks and proactive issue resolution</div>
              </div>
            </div>
            <div className="commitment-feature">
              <img src={process.env.PUBLIC_URL + "/assets/icons/commit.png"} alt="Auto-Scaling" className="commitment-feature-icon" />
              <div className="commitment-feature-content">
                <span className="commitment-feature-title">Auto-Scaling</span>
                <div className="commitment-feature-desc">Seamlessly handle traffic spikes without performance degradation</div>
              </div>
            </div>
            <div className="commitment-feature">
              <img src={process.env.PUBLIC_URL + "/assets/icons/commit.png"} alt="Data Redundancy" className="commitment-feature-icon" />
              <div className="commitment-feature-content">
                <span className="commitment-feature-title">Data Redundancy</span>
                <div className="commitment-feature-desc">Multi-region backups ensure your data is always safe and accessible</div>
              </div>
            </div>
            <div className="commitment-feature">
              <img src={process.env.PUBLIC_URL + "/assets/icons/commit.png"} alt="Security First" className="commitment-feature-icon" />
              <div className="commitment-feature-content">
                <span className="commitment-feature-title">Security First</span>
                <div className="commitment-feature-desc">Regular security audits and compliance with global standards</div>
              </div>
            </div>
          </div>
          </div>
        </section>
        {/* READY TO TRANSFORM SECTION */}
        <section className="get-in-touch-section">
          <div className="get-in-touch-container">
            <h1 className="get-in-touch-title">Ready to Transform Your Business?</h1>
            <p className="get-in-touch-subtitle">
              Join one hundred of companies already leveraging our technology to scale, innovate, and stay ahead of the competition.
            </p>
            <div className="get-in-touch-btn-center">
              <LetsTalkButton />
            </div>
          </div>
        </section>
    </>
  );
}
